import React from 'react';
import QuickDemoInterviewContent from './QuickDemoInterviewContent.jsx';

const QuickActionsContent = () => <QuickDemoInterviewContent />;

export default QuickActionsContent;
